import React from 'react';
import { Link } from 'react-router-dom';
import ManagerHeader from "../../common/ManagerHeader";
import ManagerSidebar from "../../common/ManagerSidebar";
import AgentHeader from "../../common/AgentHeader";
import AgentSideBar from "../../common/AgentSideBar";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { getApiData } from '../../../services/Api';
import { CSVLink, CSVDownload } from "react-csv";
import 'react-input-range/lib/css/index.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PropTypes from 'prop-types';
class Buildings1 extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			get_RLS_avgprice: [],
			get_opens_avgprice: [],
			get_opens_RLS_avgprice: [],
			get_current_avai_apartment: [],
			get_lastmonth_rented: [],
			get_apartment_offer_incentives: [],
			get_avg_total_market: [],
			changevalue: 'RLS_Open',
			from_Date: '',
			to_Date: '',
			activeTabIndex: 'Rental',
			linkingLoader: false,
			neighborDW: [],
			searchNeighbor: '',
			get_avg_total_market_avai_apartment: 0,
			get_avg_total_market_rented: 0,
			get_avg_total_market_incentives: 0



		};
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.setWrapperRef1 = this.setWrapperRef1.bind(this);
		this.setWrapperRef2 = this.setWrapperRef2.bind(this);
		this.setWrapperRef3 = this.setWrapperRef3.bind(this);
		this.setWrapperRef4 = this.setWrapperRef4.bind(this);
		this.setWrapperRef5 = this.setWrapperRef5.bind(this);

	}
	StatusNeighborClick() { document.getElementById('neighbor').classList.add("show"); }
	StatusNeighborClick1() { document.getElementById('neighbor1').classList.add("show"); }
	StatusNeighborClick2() { document.getElementById('neighbor2').classList.add("show"); }
	StatusNeighborClick3() { document.getElementById('neighbor3').classList.add("show"); }
	StatusNeighborClick4() { document.getElementById('neighbor4').classList.add("show"); }

	setWrapperRef1(node) {
		this.wrapperRef1 = node;
	}
	setWrapperRef2(node) {
		this.wrapperRef2 = node;
	}
	setWrapperRef3(node) {
		this.wrapperRef3 = node;
	}
	setWrapperRef4(node) {
		this.wrapperRef4 = node;
	}
	setWrapperRef5(node) {
		this.wrapperRef5 = node;
	}

	componentWillMount() {
		window.scroll(0, 0);
		this.get_RLS_avgprice();
		this.get_opens_avgprice();
		this.get_opens_RLS_avgprice();
		this.get_current_avai_apartment();
		this.get_lastmonth_rented();
		this.get_apartment_offer_incentives();
		//	this.get_avg_total_market();
		this.get_avg_total_market_avai_apartment();
		this.get_avg_total_market_rented();
		this.get_avg_total_market_incentives();
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);

	}
	handleClickOutside(event) {


		if (this.wrapperRef1 && !this.wrapperRef1.contains(event.target)) {
			document.getElementById('neighbor').classList.remove("show");
		}
		if (this.wrapperRef2 && !this.wrapperRef2.contains(event.target)) {
			document.getElementById('neighbor1').classList.remove("show");
		}
		if (this.wrapperRef3 && !this.wrapperRef3.contains(event.target)) {
			document.getElementById('neighbor2').classList.remove("show");
		}
		if (this.wrapperRef4 && !this.wrapperRef4.contains(event.target)) {
			document.getElementById('neighbor3').classList.remove("show");
		}
		if (this.wrapperRef5 && !this.wrapperRef5.contains(event.target)) {
			document.getElementById('neighbor4').classList.remove("show");
		}

	}

	get_RLS_avgprice = () => {
		this.setState({ linkingLoader: true });
		let listingWhere = [{
			url: "/managers/get_RLS_avgprice",
		}];

		if (this.state.from_Date.toString().trim() != '' && this.state.to_Date.toString().trim() != '' && this.state.activeTabIndex != '') {
			listingWhere[0].where = {
				from_Date: this.state.from_Date,
				to_Date: this.state.to_Date,
				listing_type: this.state.activeTabIndex
			};
			//listingWhere[0].where.to_Date=this.state.to_Date;
		}
		else if (this.state.activeTabIndex != '') {
			listingWhere[0].where = {
				listing_type: this.state.activeTabIndex
			};
		}

		getApiData(listingWhere, true).then(res => {
			console.log('get_RLS_avgprice==>', res.data)

			this.setState({
				get_RLS_avgprice: res.data
			}, () => {
				this.setState({ linkingLoader: false });
			})
		}).catch(err => {


		})
	}

	get_opens_avgprice = () => {
		let listingWhere = [{
			url: "/managers/get_opens_avgprice",
		}];
		if (this.state.from_Date.toString().trim() != '' && this.state.to_Date.toString().trim() != '') {
			listingWhere[0].where = {
				from_Date: this.state.from_Date,
				to_Date: this.state.to_Date,
				listing_type: this.state.activeTabIndex
			};
			//listingWhere[0].where.to_Date=this.state.to_Date;
		}
		else if (this.state.activeTabIndex != '') {
			listingWhere[0].where = {
				listing_type: this.state.activeTabIndex
			};
		}

		getApiData(listingWhere, true).then(res => {
			console.log('get_opens_avgprice==>', res.data)
			this.setState({
				get_opens_avgprice: res.data
			}, () => {
				this.setState({ linkingLoader: false });
			})
		}).catch(err => {


		})
	}

	get_opens_RLS_avgprice = () => {
		let listingWhere = [{
			url: "/managers/get_opens_RLS_avgprice",
		}];
		if (this.state.from_Date.toString().trim() != '' && this.state.to_Date.toString().trim() != '') {
			listingWhere[0].where = {
				from_Date: this.state.from_Date,
				to_Date: this.state.to_Date,
				listing_type: this.state.activeTabIndex
			};
			//listingWhere[0].where.to_Date=this.state.to_Date;
		}
		else if (this.state.activeTabIndex != '') {
			listingWhere[0].where = {
				listing_type: this.state.activeTabIndex
			};
		}
		getApiData(listingWhere, true).then(res => {
			console.log('get_opens_RLS_avgprice==>', res.data)
			this.setState({
				get_opens_RLS_avgprice: res.data
			}, () => {
				this.setState({ linkingLoader: false });
			})
		}).catch(err => {


		})
	}

	get_current_avai_apartment = () => {
		let listingWhere = [{
			url: "/managers/get_current_avai_apartment",
		}];
		if (this.state.from_Date.toString().trim() != '' && this.state.to_Date.toString().trim() != '') {
			listingWhere[0].where = {
				from_Date: this.state.from_Date,
				to_Date: this.state.to_Date,
				listing_type: this.state.activeTabIndex,
				list_type_value: this.state.changevalue
			};
			//listingWhere[0].where.to_Date=this.state.to_Date;
		}
		else if (this.state.activeTabIndex != '') {
			listingWhere[0].where = {
				listing_type: this.state.activeTabIndex,
				list_type_value: this.state.changevalue
			};
		}
		// else if(this.state.changevalue!=''){
		// 	listingWhere[0].where={
		// 		list_type_value:this.state.changevalue
		// 		};
		// }

		getApiData(listingWhere, true).then(res => {
			console.log('get_current_avai_apartment==>', res.data)
			this.setState({
				get_current_avai_apartment: res.data
			}, () => {
				this.setState({ linkingLoader: false });
			})
		}).catch(err => {


		})
	}

	get_lastmonth_rented = () => {
		let listingWhere = [{
			url: "/managers/get_lastmonth_rented",
		}];
		if (this.state.from_Date.toString().trim() != '' && this.state.to_Date.toString().trim() != '') {
			listingWhere[0].where = {
				from_Date: this.state.from_Date,
				to_Date: this.state.to_Date,
				listing_type: this.state.activeTabIndex,
				list_type_value: this.state.changevalue
			};
			//listingWhere[0].where.to_Date=this.state.to_Date;
		}
		else if (this.state.activeTabIndex != '') {
			listingWhere[0].where = {
				listing_type: this.state.activeTabIndex,
				list_type_value: this.state.changevalue
			};
		}
		// else if(this.state.changevalue!=''){
		// 	listingWhere[0].where={
		// 		list_type_value:this.state.changevalue
		// 		};
		// }
		getApiData(listingWhere, true).then(res => {
			console.log('get_lastmonth_rented==>', res.data)
			this.setState({
				get_lastmonth_rented: res.data
			}, () => {
				this.setState({ linkingLoader: false });
			})
		}).catch(err => {


		})
	}

	get_apartment_offer_incentives = () => {
		let listingWhere = [{
			url: "/managers/get_apartment_offer_incentives",
		}];
		if (this.state.from_Date.toString().trim() != '' && this.state.to_Date.toString().trim() != '') {
			listingWhere[0].where = {
				from_Date: this.state.from_Date,
				to_Date: this.state.to_Date,
				listing_type: this.state.activeTabIndex,
				list_type_value: this.state.changevalue
			};
			//listingWhere[0].where.to_Date=this.state.to_Date;
		}
		else if (this.state.activeTabIndex != '') {
			listingWhere[0].where = {
				listing_type: this.state.activeTabIndex,
				list_type_value: this.state.changevalue
			};
		}
		// else if(this.state.changevalue!=''){
		// 	listingWhere[0].where={
		// 		list_type_value:this.state.changevalue
		// 		};
		// }
		getApiData(listingWhere, true).then(res => {
			console.log('get_apartment_offer_incentives==>', res.data)
			this.setState({
				get_apartment_offer_incentives: res.data
			}, () => {
				this.setState({ linkingLoader: false });
			})
		}).catch(err => {


		})
	}

	// get_avg_total_market=()=>
	// {
	//        let listingWhere=[{
	//           url :"/managers/get_avg_total_market",
	//         }];
	// 		if(this.state.from_Date.toString().trim()!='' && this.state.to_Date.toString().trim()!=''){
	// 			listingWhere[0].where={
	// 				from_Date:this.state.from_Date,
	// 				to_Date:this.state.to_Date,
	// 				listing_type:this.state.activeTabIndex,
	// 				list_type_value:this.state.changevalue
	// 			};
	// 			//listingWhere[0].where.to_Date=this.state.to_Date;
	// 		}
	// 		else if(this.state.activeTabIndex!=''){
	// 			listingWhere[0].where={
	// 				listing_type:this.state.activeTabIndex,
	// 				list_type_value:this.state.changevalue
	// 				};
	// 		}
	// 		// else if(this.state.changevalue!=''){
	// 		// 	listingWhere[0].where={
	// 		// 		list_type_value:this.state.changevalue
	// 		// 		};
	// 		// }
	//   getApiData(listingWhere,true).then(res=>{
	// 	console.log('get_avg_total_market==>',res.data)
	//       this.setState({
	// 		get_avg_total_market:res.data
	//           },()=>{
	// 			this.setState({linkingLoader:false});
	//       })
	//   }).catch(err=>{


	// }) 
	// }

	get_avg_total_market_avai_apartment = () => {
		let listingWhere = [{
			url: "/managers/get_avg_total_market_avai_apartment",
		}];
		if (this.state.from_Date.toString().trim() != '' && this.state.to_Date.toString().trim() != '') {
			listingWhere[0].where = {
				from_Date: this.state.from_Date,
				to_Date: this.state.to_Date,
				listing_type: this.state.activeTabIndex,
				list_type_value: this.state.changevalue
			};
			//listingWhere[0].where.to_Date=this.state.to_Date;
		}
		else if (this.state.activeTabIndex != '') {
			listingWhere[0].where = {
				listing_type: this.state.activeTabIndex,
				list_type_value: this.state.changevalue
			};
		}
		// else if(this.state.changevalue!=''){
		// 	listingWhere[0].where={
		// 		list_type_value:this.state.changevalue
		// 		};
		// }
		getApiData(listingWhere, true).then(res => {
			console.log('get_avg_total_market_avai_apartment==>', res.data)
			if (res.data[0].total_apartment != null) {
				this.setState({
					get_avg_total_market_avai_apartment: res.data[0].total_apartment
				}, () => {
					this.setState({ linkingLoader: false });
				})
			}
			else {
				this.setState({
					get_avg_total_market_avai_apartment: 0
				})
			}

		}).catch(err => {


		})
	}

	get_avg_total_market_rented = () => {
		let listingWhere = [{
			url: "/managers/get_avg_total_market_rented",
		}];
		if (this.state.from_Date.toString().trim() != '' && this.state.to_Date.toString().trim() != '') {
			listingWhere[0].where = {
				from_Date: this.state.from_Date,
				to_Date: this.state.to_Date,
				listing_type: this.state.activeTabIndex,
				list_type_value: this.state.changevalue
			};
			//listingWhere[0].where.to_Date=this.state.to_Date;
		}
		else if (this.state.activeTabIndex != '') {
			listingWhere[0].where = {
				listing_type: this.state.activeTabIndex,
				list_type_value: this.state.changevalue
			};
		}
		// else if(this.state.changevalue!=''){
		// 	listingWhere[0].where={
		// 		list_type_value:this.state.changevalue
		// 		};
		// }
		getApiData(listingWhere, true).then(res => {

			if (res.data[0].rented_apartment != null) {
				this.setState({
					get_avg_total_market_rented: res.data[0].rented_apartment
				}, () => {
					this.setState({ linkingLoader: false });
				})
			}
			else {
				this.setState({
					get_avg_total_market_rented: 0
				})
			}
		}).catch(err => {


		})
	}

	get_avg_total_market_incentives = () => {
		let listingWhere = [{
			url: "/managers/get_avg_total_market_incentives",
		}];
		if (this.state.from_Date.toString().trim() != '' && this.state.to_Date.toString().trim() != '') {
			listingWhere[0].where = {
				from_Date: this.state.from_Date,
				to_Date: this.state.to_Date,
				listing_type: this.state.activeTabIndex,
				list_type_value: this.state.changevalue
			};
			//listingWhere[0].where.to_Date=this.state.to_Date;
		}
		else if (this.state.activeTabIndex != '') {
			listingWhere[0].where = {
				listing_type: this.state.activeTabIndex,
				list_type_value: this.state.changevalue
			};
		}
		// else if(this.state.changevalue!=''){
		// 	listingWhere[0].where={
		// 		list_type_value:this.state.changevalue
		// 		};
		// }
		getApiData(listingWhere, true).then(res => {
			console.log('get_avg_total_market_incentives==>', res.data)
			if (res.data[0].total_incentives != null) {
				this.setState({
					get_avg_total_market_incentives: res.data[0].total_incentives
				}, () => {
					this.setState({ linkingLoader: false });
				})
			}
			else {
				this.setState({
					get_avg_total_market_incentives: 0
				});
			}
		}).catch(err => {


		})
	}

	changevalue = (event) => {
		if (event.target.id == "changevalue") {
			this.setState({
				[event.target.id]: event.target.value
			}, () => {
				this.get_RLS_avgprice();
				this.get_opens_avgprice();
				this.get_opens_RLS_avgprice();
				this.get_current_avai_apartment();
				this.get_lastmonth_rented();
				this.get_apartment_offer_incentives();
				//this.get_avg_total_market();
				this.get_avg_total_market_avai_apartment();
				this.get_avg_total_market_rented();
				this.get_avg_total_market_incentives();

			})
		}
	}

	handleChangeDate = (Date_value) => {

		if (Date_value == "" || Date_value == null) {

			this.setState({
				from_Date: '',


			});
		}
		else {
			this.setState({
				from_Date: Date_value,
			});
		}

	}

	handleChangetoDate = (Date_value) => {

		if (Date_value == "" || Date_value == null) {

			this.setState({
				to_Date: '',


			});
		}
		else {
			this.setState({
				to_Date: Date_value,
			});
		}

	}

	validation = () => {
		return (
			this.state.from_Date.toString().trim() != '' &&
			this.state.to_Date.toString().trim() != ''
		)
	}

	handlesetdate() {
		this.get_RLS_avgprice();
		this.get_opens_avgprice();
		this.get_opens_RLS_avgprice();
		this.get_current_avai_apartment();
		this.get_lastmonth_rented();
		this.get_apartment_offer_incentives();
		//this.get_avg_total_market();
		this.get_avg_total_market_avai_apartment();
		this.get_avg_total_market_rented();
		this.get_avg_total_market_incentives();

	}

	resetFilter = () => {
		this.setState({
			from_Date: '',
			to_Date: ''
		}, () => {
			this.get_RLS_avgprice();
			this.get_opens_avgprice();
			this.get_opens_RLS_avgprice();
			this.get_current_avai_apartment();
			this.get_lastmonth_rented();
			this.get_apartment_offer_incentives();
			//this.get_avg_total_market();
			this.get_avg_total_market_avai_apartment();
			this.get_avg_total_market_rented();
			this.get_avg_total_market_incentives();
		})
	}

	handleClickOnList = param => e => {
		var value = param[0];

		this.getData(value, e.target.id);

	}
	getData(value, id) {
		if (id == 'searchNeighbor') {
			this.setState({ searchNeighborhood: value }, () => {
				this.state.get_opens_RLS_avgprice.forEach(function (neighbor, index) {
					if (neighbor.neighborhood == value) {
						document.getElementById('neighborClick').classList.add("active");
						document.getElementById('searchNeighborParam').value = neighbor.neighborhood;
						document.getElementById('neighbor').classList.remove("show");
					}
					else {
						neighbor.flag = 0;
					}
				});
				document.getElementById('neighborClick').classList.add("active");
				this.createWhere();
			});
		}

	}

	async createWhere() {
		this.state.where = {};
		var inValue = "";

		if (this.state.searchNeighborhood != '')
			this.state.where.searchNeighborhood = this.state.searchNeighborhood;



		this.get_opens_RLS_avgprice();
	}

	search = (event) => {

		var key = event.target.id;

		switch (key) {


			case 'searchNeighborParam':
				this.setState({ searchNeighbor: event.target.value });
				//if(this.state.searchParm.length>1){	
				var value = this.state.searchNeighbor.trim();
				if (event.key == 'Enter') {
					this.getData(value);

				} else if (value == '') {

					this.state.get_opens_RLS_avgprice.forEach(function (address, index) {
						address.flag = 0;
					});
					this.setState({ searchMsg: false });
				} else {
					var len = this.state.get_opens_RLS_avgprice.length;

					var count = 0;
					var vflag = 0;
					this.state.get_opens_RLS_avgprice.forEach(function (address, index) {


						if (address.neighborhood.trim().toLowerCase().includes(value.trim().toLowerCase())) {
							address.flag = 1;
							vflag = 1;
							count = count + 1;
						}
						else {
							address.flag = 0;
							if (vflag != 1)
								vflag = 0
							count = count + 1;
						}

					});

					if (len == count) {
						if (vflag == 0) {
							this.setState({ searchMsg: true });

						} else {
							this.setState({ searchMsg: false });

						}
					}
				}
				break;

			case 'searchNeighbor':
				var value = event.target.value;
				this.setState({ searchNeighborhood: event.target.value }, () => {
					this.state.get_opens_RLS_avgprice.forEach(function (address, index) {
						if (address.neighborhood == value) {
							document.getElementById('neighborClick').classList.add("active");
							document.getElementById('searchNeighborParam').value = address.neighborhood;
							//document.getElementById('search').classList.remove("show");
						} else {
							address.flag = 0;
						}
					});
					document.getElementById('neighborClick').classList.add("active");
					this.createWhere();
				});
				break;


		}


	}


	render() {
		const { userType, heading } = this.props;
		let get_opens_RLS_avgprice = this.state.get_opens_RLS_avgprice.map((s) =>
			<tr>
				<td align="center">{s.studio ? '$' + s.studio.toFixed(2) : '$' + s.studio.toFixed(2)}</td>
				<td align="center">{s.one_bedroom ? '$' + s.one_bedroom.toFixed(2) : '$' + s.one_bedroom.toFixed(2)}</td>
				<td align="center">{s.two_bedroom ? '$' + s.two_bedroom.toFixed(2) : '$' + s.two_bedroom.toFixed(2)}</td>
				<td align="center">{s.three_bedroom ? '$' + s.three_bedroom.toFixed(2) : '$' + s.three_bedroom.toFixed(2)}</td>
				<td align="center">{s.four_bedroom ? '$' + s.four_bedroom.toFixed(2) : '$' + s.four_bedroom.toFixed(2)}</td>
				<td align="center">{unescape(s.neighborhood)}</td>
			</tr>
		);

		let get_RLS_avgprice = this.state.get_RLS_avgprice.map((s) =>
			<tr>
				<td align="center">{s.studio ? '$' + s.studio.toFixed(2) : '$' + s.studio.toFixed(2)}</td>
				<td align="center">{s.one_bedroom ? '$' + s.one_bedroom.toFixed(2) : '$' + s.one_bedroom.toFixed(2)}</td>
				<td align="center">{s.two_bedroom ? '$' + s.two_bedroom.toFixed(2) : '$' + s.two_bedroom.toFixed(2)}</td>
				<td align="center">{s.three_bedroom ? '$' + s.three_bedroom.toFixed(2) : '$' + s.three_bedroom.toFixed(2)}</td>
				<td align="center">{s.four_bedroom ? '$' + s.four_bedroom.toFixed(2) : '$' + s.four_bedroom.toFixed(2)}</td>
				<td align="center">{unescape(s.neighborhood)}</td>
			</tr>
		);

		let get_opens_avgprice = this.state.get_opens_avgprice.map((s) =>
			<tr>
				<td align="center">{s.studio ? '$' + s.studio.toFixed(2) : '$' + s.studio.toFixed(2)}</td>
				<td align="center">{s.one_bedroom ? '$' + s.one_bedroom.toFixed(2) : '$' + s.one_bedroom.toFixed(2)}</td>
				<td align="center">{s.two_bedroom ? '$' + s.two_bedroom.toFixed(2) : '$' + s.two_bedroom.toFixed(2)}</td>
				<td align="center">{s.three_bedroom ? '$' + s.three_bedroom.toFixed(2) : '$' + s.three_bedroom.toFixed(2)}</td>
				<td align="center">{s.four_bedroom ? '$' + s.studio.toFixed(2) : '$' + s.four_bedroom.toFixed(2)}</td>
				<td align="center">{unescape(s.neighborhood)}</td>
			</tr>
		);

		let get_current_avai_apartment = this.state.get_current_avai_apartment.map((s) =>
			<tr>
				<td align="center">{s.total_apartment}</td>
				<td align="center">{unescape(s.neighborhood)}</td>
			</tr>
		);

		let get_lastmonth_rented = this.state.get_lastmonth_rented.map((s) =>
			<tr>
				<td align="center">{s.total_rented}</td>
				<td align="center">{unescape(s.neighborhood)}</td>
			</tr>
		);

		let get_apartment_offer_incentives = this.state.get_apartment_offer_incentives.map((s) =>
			<tr>
				<td align="center">{s.total_apartment}</td>
				<td align="center">{unescape(s.neighborhood)}</td>
			</tr>
		);

		// let get_avg_total_market = this.state.get_avg_total_market.map((s) =>
		// <tr>
		//   <td  align="center">{s.total_apartment}</td>
		//   <td  align="center">{s.rented_apartment}</td>
		//   <td  align="center">{s.total_incentives}</td>
		// </tr>
		// );



		const neighborDW = this.state.get_opens_RLS_avgprice.map((dw, index) =>
			(dw.flag == 1) ? <li id="searchNeighbor" onClick={this.handleClickOnList([dw.neighborhood])}>{dw.neighborhood}</li> : ''
		);
		return (

			<div onclick="myFunction()">

				{userType == 'Agent' ? <AgentHeader /> : <ManagerHeader />}
				<main>
					{userType == 'Agent' ? <AgentSideBar /> : <ManagerSidebar />}
					<div className="content">
						<div className="work-section">
							<div className="dashboard" >

								{(this.state.linkingLoader) ? <div className="show_loader_on_click" id="show_loader_on_click"></div> : ''}

								<Tabs>
									<TabList>
										<Tab onClick={() => this.setState({ activeTabIndex: 'Rental', changevalue: 'RLS_Open', from_Date: '', to_Date: '' }, () => {
											this.get_RLS_avgprice();
											this.get_opens_avgprice();
											this.get_opens_RLS_avgprice();
											this.get_current_avai_apartment();
											this.get_lastmonth_rented();
											this.get_apartment_offer_incentives();
											//this.get_avg_total_market();
											this.get_avg_total_market_avai_apartment();
											this.get_avg_total_market_rented();
											this.get_avg_total_market_incentives();
										})}>Rental</Tab>
										<Tab onClick={() => this.setState({ activeTabIndex: 'Sales', changevalue: 'RLS_Open', from_Date: '', to_Date: '' }, () => {
											this.get_RLS_avgprice();
											this.get_opens_avgprice();
											this.get_opens_RLS_avgprice();
											this.get_current_avai_apartment();
											this.get_lastmonth_rented();
											this.get_apartment_offer_incentives();
											//this.get_avg_total_market();
											this.get_avg_total_market_avai_apartment();
											this.get_avg_total_market_rented();
											this.get_avg_total_market_incentives();
										})}>Sale</Tab>
									</TabList>
									<TabPanel>
										<div style={{ maxWidth: '715px', margin: '20px auto' }}>
											<button class="btn btn-default search-filter pull-right mr-5" onClick={this.resetFilter} style={{ 'margin-bottom': '0px' }}><img src="/reset-filter.png" width="55" /></button>
											<div className="clearfix"></div></div>
										<div className="marketing-filter">
											<div className="row">

												<div className="col-sm-3">
													<div className="form-group">

														<DatePicker
															selected={this.state.from_Date}
															onChange={this.handleChangeDate}
															dateFormat="MMMM d, yyyy"
															timeCaption="time"
															className="form-control"
															id="from_Date"
															placeholderText="Date From"
														/>
														{/* <input type="Text" class="form-control" placeholder="Date From"/> */}
													</div>
												</div>
												<div className="col-sm-3">
													<div className="form-group">


														<DatePicker
															selected={this.state.to_Date}
															onChange={this.handleChangetoDate}
															dateFormat="MMMM d, yyyy"
															timeCaption="time"
															className="form-control"
															id="to_Date"
															placeholderText="Date To"
														/>
														{/* <input type="Text" class="form-control" placeholder="Date To"/> */}
													</div>
												</div>
												<div className="col-sm-4">
													<div className="form-group">
														<select class="form-control" id="changevalue" onChange={this.changevalue}>
															<option value="RLS_Open">RLS and Open</option>
															<option value="RLS">RLS</option>
															<option value="Open">Open</option>
														</select>
													</div>
												</div>

												<div className="col-sm-2 text-center">
													<div className="search-wrap"><button className="btn btn-default search-filter" disabled={!this.validation()} onClick={() => this.handlesetdate()}><img src="/search-filter.png" width="55" style={{ 'padding-right': '4px' }} /></button>
													</div>
												</div>
											</div>

										</div>

										<div className="clearfix">
											<h2 className="pull-left">Average current price</h2>
											<span className="pull-right">
												{/* <Link to>
											<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M22.1692 8.94238H21.5689V6.04588C21.5689 6.02782 21.566 6.00963 21.5639 5.99116C21.5629 5.87626 21.5261 5.76332 21.4474 5.67381L16.627 0.167657C16.6255 0.166244 16.6241 0.165742 16.6231 0.164238C16.5944 0.132138 16.5609 0.105418 16.5254 0.0823468C16.515 0.075325 16.5044 0.069443 16.4934 0.063242C16.4628 0.0465993 16.4302 0.0326013 16.3967 0.0225245C16.3876 0.0201535 16.3794 0.0164146 16.3704 0.0140436C16.334 0.00538035 16.2962 0 16.2579 0H4.41179C3.87088 0 3.43142 0.439958 3.43142 0.98041V8.9421H2.8312C2.05738 8.9421 1.42993 9.56933 1.42993 10.3434V17.6302C1.42993 18.4036 2.05738 19.0315 2.8312 19.0315H3.43142V24.0196C3.43142 24.5601 3.87088 25 4.41179 25H20.5882C21.1287 25 21.5686 24.5601 21.5686 24.0196V19.0315H22.1689C22.9425 19.0315 23.5701 18.4039 23.5701 17.6303V10.3437C23.5701 9.56937 22.943 8.94238 22.1692 8.94238ZM4.41179 0.98041H15.7677V5.99627C15.7677 6.26711 15.9874 6.48647 16.2579 6.48647H20.5883V8.94233H4.41179V0.98041ZM14.3435 14.3474C13.3803 14.0118 12.7518 13.479 12.7518 12.6355C12.7518 11.6461 13.5776 10.8893 14.9458 10.8893C15.5992 10.8893 16.0812 11.0267 16.425 11.1817L16.1327 12.2395C15.9005 12.128 15.4877 11.9643 14.9199 11.9643C14.3521 11.9643 14.0769 12.2224 14.0769 12.5235C14.0769 12.8936 14.4039 13.0568 15.1521 13.3407C16.1755 13.7194 16.6573 14.2526 16.6573 15.0697C16.6573 16.042 15.9089 16.8678 14.3174 16.8678C13.6552 16.8678 13.0015 16.696 12.6746 16.515L12.941 15.4312C13.2938 15.6117 13.8359 15.7927 14.3948 15.7927C14.9975 15.7927 15.3153 15.5433 15.3153 15.1646C15.3155 14.8036 15.0403 14.5967 14.3435 14.3474ZM12.1248 15.6805V16.782H8.50273V10.9833H9.81941V15.6805H12.1248ZM4.29689 16.782H2.80014L4.47754 13.8478L2.8601 10.9831H4.36574L4.87299 12.0414C5.04507 12.3941 5.1742 12.6776 5.312 13.005H5.32873C5.46675 12.635 5.57846 12.377 5.72428 12.0414L6.21471 10.9831H7.7115L6.07696 13.8131L7.79776 16.7815H6.28388L5.75884 15.7318C5.54413 15.328 5.40638 15.0266 5.24287 14.6911H5.22577C5.10517 15.0266 4.95926 15.328 4.77843 15.7318L4.29689 16.782ZM20.5883 23.7542H4.41179V19.0315H20.5882V23.7542H20.5883ZM20.5971 16.782L20.0722 15.7323C19.8572 15.3282 19.7196 15.0271 19.5561 14.6916H19.5394C19.4188 15.0271 19.2723 15.3282 19.0914 15.7323L18.6103 16.782H17.1131L18.7905 13.8478L17.1731 10.9831H18.6787L19.1866 12.0414C19.3585 12.3941 19.4872 12.6776 19.6252 13.005H19.6423C19.7797 12.635 19.8913 12.377 20.0377 12.0414L20.528 10.9831H22.0251L20.3905 13.8131L22.111 16.7815H20.5971V16.782Z" fill="black"/>
											</svg>
										</Link> */}
											</span>
										</div>
										<div className="panel-body table-responsive mb-5" style={{ overflow: 'auto', maxHeight: '400px' }}>
											<table className="table table-striped table-fixed" >
												<thead>
													<tr>
														<th style={{ textAlign: 'center' }}>Studio</th>
														<th style={{ textAlign: 'center' }}>1 Bed</th>
														<th style={{ textAlign: 'center' }}>2 Bed</th>
														<th style={{ textAlign: 'center' }}>3 Bed</th>
														<th style={{ textAlign: 'center' }}>4 Bed</th>
														<th style={{ textAlign: 'center' }}>Neighborhood
															{/* <Link to id="neighborClick" data-toggle="collapse" data-target="#neighborhood" className="icon-wrap status" onClick={this.StatusNeighborClick} ></Link>												
												 <div id="neighbor" class="collapse table-collapse status-collapse"  ref={this.setWrapperRef1}>
												<div className="box">
												<input type="text" style={{maxWidth:'151px'}} id="searchNeighborParam" autoComplete="off" class="search-input" onChange={this.search}  onKeyDownCapture={this.search} onKeyUpCapture={this.search} />
												<span onClick={this.resetsearchParm} className="pull-right">(X)</span>
												
												<ul>
													{neighborDW}
													</ul>

												</div>
							 					</div> */}
														</th>
													</tr>
												</thead>

												<tbody >
													{this.state.changevalue == 'RLS_Open' ? this.state.get_opens_RLS_avgprice.length > 0 ? get_opens_RLS_avgprice : <tr><td colspan="6" style={{ textAlign: 'center' }}>No record found</td></tr> : this.state.changevalue == 'RLS' ? this.state.get_RLS_avgprice.length > 0 ? get_RLS_avgprice : <tr><td colspan="2" style={{ textAlign: 'center' }}>No record found</td></tr> : this.state.changevalue == 'Open' ? this.state.get_opens_avgprice.length > 0 ? get_opens_avgprice : <tr><td colspan="2" style={{ textAlign: 'center' }}>No record found</td></tr> : ''}
													{/* <tr>
													<td>$1,05,000</td>
													<td>$1,55,000</td>
													<td>$3,05,000</td>
													<td>$4,05,000</td>
													<td>$1,05,000</td>
													<td>Astoria</td>
												</tr>
												<tr>
													<td>$1,05,000</td>
													<td>$1,55,000</td>
													<td>$3,05,000</td>
													<td>$4,05,000</td>
													<td>$1,05,000</td>
													<td>Williamburg</td>
												</tr>
												<tr>
													<td>$1,05,000</td>
													<td>$1,55,000</td>
													<td>$3,05,000</td>
													<td>$4,05,000</td>
													<td>$1,05,000</td>
													<td>Upper East Side</td>
												</tr> */}
												</tbody>

											</table>

										</div>


										<div className="clearfix ">
											<h2 className="pull-left">Current number of available apartments</h2>
											<span className="pull-right">
												<CSVLink data={this.state.get_current_avai_apartment} filename={"get_current_avai_apartment.csv"}>
													<img src="/csv_file.png" />
												</CSVLink>
												{/* <Link to>
											<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M22.1692 8.94238H21.5689V6.04588C21.5689 6.02782 21.566 6.00963 21.5639 5.99116C21.5629 5.87626 21.5261 5.76332 21.4474 5.67381L16.627 0.167657C16.6255 0.166244 16.6241 0.165742 16.6231 0.164238C16.5944 0.132138 16.5609 0.105418 16.5254 0.0823468C16.515 0.075325 16.5044 0.069443 16.4934 0.063242C16.4628 0.0465993 16.4302 0.0326013 16.3967 0.0225245C16.3876 0.0201535 16.3794 0.0164146 16.3704 0.0140436C16.334 0.00538035 16.2962 0 16.2579 0H4.41179C3.87088 0 3.43142 0.439958 3.43142 0.98041V8.9421H2.8312C2.05738 8.9421 1.42993 9.56933 1.42993 10.3434V17.6302C1.42993 18.4036 2.05738 19.0315 2.8312 19.0315H3.43142V24.0196C3.43142 24.5601 3.87088 25 4.41179 25H20.5882C21.1287 25 21.5686 24.5601 21.5686 24.0196V19.0315H22.1689C22.9425 19.0315 23.5701 18.4039 23.5701 17.6303V10.3437C23.5701 9.56937 22.943 8.94238 22.1692 8.94238ZM4.41179 0.98041H15.7677V5.99627C15.7677 6.26711 15.9874 6.48647 16.2579 6.48647H20.5883V8.94233H4.41179V0.98041ZM14.3435 14.3474C13.3803 14.0118 12.7518 13.479 12.7518 12.6355C12.7518 11.6461 13.5776 10.8893 14.9458 10.8893C15.5992 10.8893 16.0812 11.0267 16.425 11.1817L16.1327 12.2395C15.9005 12.128 15.4877 11.9643 14.9199 11.9643C14.3521 11.9643 14.0769 12.2224 14.0769 12.5235C14.0769 12.8936 14.4039 13.0568 15.1521 13.3407C16.1755 13.7194 16.6573 14.2526 16.6573 15.0697C16.6573 16.042 15.9089 16.8678 14.3174 16.8678C13.6552 16.8678 13.0015 16.696 12.6746 16.515L12.941 15.4312C13.2938 15.6117 13.8359 15.7927 14.3948 15.7927C14.9975 15.7927 15.3153 15.5433 15.3153 15.1646C15.3155 14.8036 15.0403 14.5967 14.3435 14.3474ZM12.1248 15.6805V16.782H8.50273V10.9833H9.81941V15.6805H12.1248ZM4.29689 16.782H2.80014L4.47754 13.8478L2.8601 10.9831H4.36574L4.87299 12.0414C5.04507 12.3941 5.1742 12.6776 5.312 13.005H5.32873C5.46675 12.635 5.57846 12.377 5.72428 12.0414L6.21471 10.9831H7.7115L6.07696 13.8131L7.79776 16.7815H6.28388L5.75884 15.7318C5.54413 15.328 5.40638 15.0266 5.24287 14.6911H5.22577C5.10517 15.0266 4.95926 15.328 4.77843 15.7318L4.29689 16.782ZM20.5883 23.7542H4.41179V19.0315H20.5882V23.7542H20.5883ZM20.5971 16.782L20.0722 15.7323C19.8572 15.3282 19.7196 15.0271 19.5561 14.6916H19.5394C19.4188 15.0271 19.2723 15.3282 19.0914 15.7323L18.6103 16.782H17.1131L18.7905 13.8478L17.1731 10.9831H18.6787L19.1866 12.0414C19.3585 12.3941 19.4872 12.6776 19.6252 13.005H19.6423C19.7797 12.635 19.8913 12.377 20.0377 12.0414L20.528 10.9831H22.0251L20.3905 13.8131L22.111 16.7815H20.5971V16.782Z" fill="black"/>
											</svg>
										</Link> */}
											</span>
										</div>
										<div className="panel-body table-responsive mb-5" style={{ overflow: 'auto', maxHeight: '400px' }}>
											<table className="table table-striped table-fixed">
												<thead>
													<tr>
														<th style={{ textAlign: 'center' }}>Number of Apartment</th>

														<th style={{ textAlign: 'center' }}>Neighborhood
															{/*	<Link to id="neighborClick" data-toggle="collapse" data-target="#neighborhood" className="icon-wrap status" onClick={this.StatusNeighborClick1} ></Link>												
												 <div id="neighbor1" class="collapse table-collapse status-collapse"  ref={this.setWrapperRef2}>
												<div className="box">
												<input type="text" style={{maxWidth:'151px'}} id="searchNeighborParam" autoComplete="off" class="search-input" />
												<span onClick={this.resetsearchParm} className="pull-right">(X)</span>
												
													

												</div>
							 					</div> */}
														</th>
													</tr>
												</thead>
												<tbody>
													{this.state.get_current_avai_apartment.length > 0 ? get_current_avai_apartment : <tr><td colspan="2" style={{ textAlign: 'center' }}>No record found</td></tr>}
													{/* <tr>
													<td>10</td>
													
													<td>Astoria</td>
												</tr>
												<tr>
													<td>20</td>												
													<td>Williamburg</td>
												</tr>
												<tr>
													<td>40</td>												
													<td>Upper East Side</td>
												</tr> */}
												</tbody>

											</table>

										</div>

										<div className="clearfix ">
											<h2 className="pull-left">Number of apartments rented in the last 30 days</h2>
											<span className="pull-right">
												<CSVLink data={this.state.get_lastmonth_rented} filename={"get_lastmonth_rented.csv"}><img src="/csv_file.png" /></CSVLink>
												{/* <Link to>
											<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M22.1692 8.94238H21.5689V6.04588C21.5689 6.02782 21.566 6.00963 21.5639 5.99116C21.5629 5.87626 21.5261 5.76332 21.4474 5.67381L16.627 0.167657C16.6255 0.166244 16.6241 0.165742 16.6231 0.164238C16.5944 0.132138 16.5609 0.105418 16.5254 0.0823468C16.515 0.075325 16.5044 0.069443 16.4934 0.063242C16.4628 0.0465993 16.4302 0.0326013 16.3967 0.0225245C16.3876 0.0201535 16.3794 0.0164146 16.3704 0.0140436C16.334 0.00538035 16.2962 0 16.2579 0H4.41179C3.87088 0 3.43142 0.439958 3.43142 0.98041V8.9421H2.8312C2.05738 8.9421 1.42993 9.56933 1.42993 10.3434V17.6302C1.42993 18.4036 2.05738 19.0315 2.8312 19.0315H3.43142V24.0196C3.43142 24.5601 3.87088 25 4.41179 25H20.5882C21.1287 25 21.5686 24.5601 21.5686 24.0196V19.0315H22.1689C22.9425 19.0315 23.5701 18.4039 23.5701 17.6303V10.3437C23.5701 9.56937 22.943 8.94238 22.1692 8.94238ZM4.41179 0.98041H15.7677V5.99627C15.7677 6.26711 15.9874 6.48647 16.2579 6.48647H20.5883V8.94233H4.41179V0.98041ZM14.3435 14.3474C13.3803 14.0118 12.7518 13.479 12.7518 12.6355C12.7518 11.6461 13.5776 10.8893 14.9458 10.8893C15.5992 10.8893 16.0812 11.0267 16.425 11.1817L16.1327 12.2395C15.9005 12.128 15.4877 11.9643 14.9199 11.9643C14.3521 11.9643 14.0769 12.2224 14.0769 12.5235C14.0769 12.8936 14.4039 13.0568 15.1521 13.3407C16.1755 13.7194 16.6573 14.2526 16.6573 15.0697C16.6573 16.042 15.9089 16.8678 14.3174 16.8678C13.6552 16.8678 13.0015 16.696 12.6746 16.515L12.941 15.4312C13.2938 15.6117 13.8359 15.7927 14.3948 15.7927C14.9975 15.7927 15.3153 15.5433 15.3153 15.1646C15.3155 14.8036 15.0403 14.5967 14.3435 14.3474ZM12.1248 15.6805V16.782H8.50273V10.9833H9.81941V15.6805H12.1248ZM4.29689 16.782H2.80014L4.47754 13.8478L2.8601 10.9831H4.36574L4.87299 12.0414C5.04507 12.3941 5.1742 12.6776 5.312 13.005H5.32873C5.46675 12.635 5.57846 12.377 5.72428 12.0414L6.21471 10.9831H7.7115L6.07696 13.8131L7.79776 16.7815H6.28388L5.75884 15.7318C5.54413 15.328 5.40638 15.0266 5.24287 14.6911H5.22577C5.10517 15.0266 4.95926 15.328 4.77843 15.7318L4.29689 16.782ZM20.5883 23.7542H4.41179V19.0315H20.5882V23.7542H20.5883ZM20.5971 16.782L20.0722 15.7323C19.8572 15.3282 19.7196 15.0271 19.5561 14.6916H19.5394C19.4188 15.0271 19.2723 15.3282 19.0914 15.7323L18.6103 16.782H17.1131L18.7905 13.8478L17.1731 10.9831H18.6787L19.1866 12.0414C19.3585 12.3941 19.4872 12.6776 19.6252 13.005H19.6423C19.7797 12.635 19.8913 12.377 20.0377 12.0414L20.528 10.9831H22.0251L20.3905 13.8131L22.111 16.7815H20.5971V16.782Z" fill="black"/>
											</svg>
										</Link> */}
											</span>
										</div>
										<div className="panel-body table-responsive mb-5" style={{ overflow: 'auto', maxHeight: '400px' }}>
											<table className="table table-striped table-fixed">
												<thead>
													<tr>
														<th style={{ textAlign: 'center' }}>Number of Apartment</th>

														<th style={{ textAlign: 'center' }}>Neighborhood
															{/* <Link to id="neighborClick" data-toggle="collapse" data-target="#neighborhood" className="icon-wrap status" onClick={this.StatusNeighborClick2} ></Link>												
												<div id="neighbor2" class="collapse table-collapse status-collapse"  ref={this.setWrapperRef3}>
												<div className="box">
												<input type="text" style={{maxWidth:'151px'}} id="searchNeighborParam" autoComplete="off" class="search-input" />
												<span onClick={this.resetsearchParm} className="pull-right">(X)</span>
												
													

												</div>
							 					</div> */}
														</th>
													</tr>
												</thead>
												<tbody>
													{this.state.get_lastmonth_rented.length > 0 ? get_lastmonth_rented : <tr><td colspan="2" style={{ textAlign: 'center' }}>No record found</td></tr>}
													{/* <tr>
													<td>10</td>
													
													<td>Astoria</td>
												</tr>
												<tr>
													<td>20</td>												
													<td>Williamburg</td>
												</tr>
												<tr>
													<td>40</td>												
													<td>Upper East Side</td>
												</tr> */}
												</tbody>

											</table>

										</div>
										<div className="clearfix ">
											<h2 className="pull-left">Number of apartments offering an incentive</h2>
											<span className="pull-right">
												<CSVLink data={this.state.get_apartment_offer_incentives} filename={"get_apartment_offer_incentives.csv"}><img src="/csv_file.png" /></CSVLink>
												{/* <Link to>
											<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M22.1692 8.94238H21.5689V6.04588C21.5689 6.02782 21.566 6.00963 21.5639 5.99116C21.5629 5.87626 21.5261 5.76332 21.4474 5.67381L16.627 0.167657C16.6255 0.166244 16.6241 0.165742 16.6231 0.164238C16.5944 0.132138 16.5609 0.105418 16.5254 0.0823468C16.515 0.075325 16.5044 0.069443 16.4934 0.063242C16.4628 0.0465993 16.4302 0.0326013 16.3967 0.0225245C16.3876 0.0201535 16.3794 0.0164146 16.3704 0.0140436C16.334 0.00538035 16.2962 0 16.2579 0H4.41179C3.87088 0 3.43142 0.439958 3.43142 0.98041V8.9421H2.8312C2.05738 8.9421 1.42993 9.56933 1.42993 10.3434V17.6302C1.42993 18.4036 2.05738 19.0315 2.8312 19.0315H3.43142V24.0196C3.43142 24.5601 3.87088 25 4.41179 25H20.5882C21.1287 25 21.5686 24.5601 21.5686 24.0196V19.0315H22.1689C22.9425 19.0315 23.5701 18.4039 23.5701 17.6303V10.3437C23.5701 9.56937 22.943 8.94238 22.1692 8.94238ZM4.41179 0.98041H15.7677V5.99627C15.7677 6.26711 15.9874 6.48647 16.2579 6.48647H20.5883V8.94233H4.41179V0.98041ZM14.3435 14.3474C13.3803 14.0118 12.7518 13.479 12.7518 12.6355C12.7518 11.6461 13.5776 10.8893 14.9458 10.8893C15.5992 10.8893 16.0812 11.0267 16.425 11.1817L16.1327 12.2395C15.9005 12.128 15.4877 11.9643 14.9199 11.9643C14.3521 11.9643 14.0769 12.2224 14.0769 12.5235C14.0769 12.8936 14.4039 13.0568 15.1521 13.3407C16.1755 13.7194 16.6573 14.2526 16.6573 15.0697C16.6573 16.042 15.9089 16.8678 14.3174 16.8678C13.6552 16.8678 13.0015 16.696 12.6746 16.515L12.941 15.4312C13.2938 15.6117 13.8359 15.7927 14.3948 15.7927C14.9975 15.7927 15.3153 15.5433 15.3153 15.1646C15.3155 14.8036 15.0403 14.5967 14.3435 14.3474ZM12.1248 15.6805V16.782H8.50273V10.9833H9.81941V15.6805H12.1248ZM4.29689 16.782H2.80014L4.47754 13.8478L2.8601 10.9831H4.36574L4.87299 12.0414C5.04507 12.3941 5.1742 12.6776 5.312 13.005H5.32873C5.46675 12.635 5.57846 12.377 5.72428 12.0414L6.21471 10.9831H7.7115L6.07696 13.8131L7.79776 16.7815H6.28388L5.75884 15.7318C5.54413 15.328 5.40638 15.0266 5.24287 14.6911H5.22577C5.10517 15.0266 4.95926 15.328 4.77843 15.7318L4.29689 16.782ZM20.5883 23.7542H4.41179V19.0315H20.5882V23.7542H20.5883ZM20.5971 16.782L20.0722 15.7323C19.8572 15.3282 19.7196 15.0271 19.5561 14.6916H19.5394C19.4188 15.0271 19.2723 15.3282 19.0914 15.7323L18.6103 16.782H17.1131L18.7905 13.8478L17.1731 10.9831H18.6787L19.1866 12.0414C19.3585 12.3941 19.4872 12.6776 19.6252 13.005H19.6423C19.7797 12.635 19.8913 12.377 20.0377 12.0414L20.528 10.9831H22.0251L20.3905 13.8131L22.111 16.7815H20.5971V16.782Z" fill="black"/>
											</svg>
										</Link> */}
											</span>
										</div>
										<div className="panel-body table-responsive mb-5" style={{ overflow: 'auto', maxHeight: '400px' }}>
											<table className="table table-striped table-fixed">
												<thead>
													<tr>
														<th style={{ textAlign: 'center' }}>Number of Apartment</th>

														<th style={{ textAlign: 'center' }}>Neighborhood
															{/*<Link to id="neighborClick" data-toggle="collapse" data-target="#neighborhood" className="icon-wrap status" onClick={this.StatusNeighborClick3} ></Link>												
												 <div id="neighbor3" class="collapse table-collapse status-collapse"  ref={this.setWrapperRef4}>
												<div className="box">
												<input type="text" style={{maxWidth:'151px'}} id="searchNeighborParam" autoComplete="off" class="search-input" />
												<span onClick={this.resetsearchParm} className="pull-right">(X)</span>
												
													

												</div>
							 					</div> */}
														</th>
													</tr>
												</thead>
												<tbody>
													{this.state.get_apartment_offer_incentives.length > 0 ? get_apartment_offer_incentives : <tr><td colspan="2" style={{ textAlign: 'center' }}>No record found</td></tr>}
													{/* <tr>
													<td>10</td>
													
													<td>Astoria</td>
												</tr>
												<tr>
													<td>20</td>												
													<td>Williamburg</td>
												</tr>
												<tr>
													<td>40</td>												
													<td>Upper East Side</td>
												</tr> */}
												</tbody>

											</table>

										</div>

										<div className="clearfix ">
											<h2 className="pull-left">Average for the total market</h2>
											<span className="pull-right">
												{/* <CSVLink data={this.state.get_avg_total_market} filename={"get_avg_total_market.csv"}><img src="/csv_file.png" /></CSVLink> */}
												{/* <Link to>
											<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M22.1692 8.94238H21.5689V6.04588C21.5689 6.02782 21.566 6.00963 21.5639 5.99116C21.5629 5.87626 21.5261 5.76332 21.4474 5.67381L16.627 0.167657C16.6255 0.166244 16.6241 0.165742 16.6231 0.164238C16.5944 0.132138 16.5609 0.105418 16.5254 0.0823468C16.515 0.075325 16.5044 0.069443 16.4934 0.063242C16.4628 0.0465993 16.4302 0.0326013 16.3967 0.0225245C16.3876 0.0201535 16.3794 0.0164146 16.3704 0.0140436C16.334 0.00538035 16.2962 0 16.2579 0H4.41179C3.87088 0 3.43142 0.439958 3.43142 0.98041V8.9421H2.8312C2.05738 8.9421 1.42993 9.56933 1.42993 10.3434V17.6302C1.42993 18.4036 2.05738 19.0315 2.8312 19.0315H3.43142V24.0196C3.43142 24.5601 3.87088 25 4.41179 25H20.5882C21.1287 25 21.5686 24.5601 21.5686 24.0196V19.0315H22.1689C22.9425 19.0315 23.5701 18.4039 23.5701 17.6303V10.3437C23.5701 9.56937 22.943 8.94238 22.1692 8.94238ZM4.41179 0.98041H15.7677V5.99627C15.7677 6.26711 15.9874 6.48647 16.2579 6.48647H20.5883V8.94233H4.41179V0.98041ZM14.3435 14.3474C13.3803 14.0118 12.7518 13.479 12.7518 12.6355C12.7518 11.6461 13.5776 10.8893 14.9458 10.8893C15.5992 10.8893 16.0812 11.0267 16.425 11.1817L16.1327 12.2395C15.9005 12.128 15.4877 11.9643 14.9199 11.9643C14.3521 11.9643 14.0769 12.2224 14.0769 12.5235C14.0769 12.8936 14.4039 13.0568 15.1521 13.3407C16.1755 13.7194 16.6573 14.2526 16.6573 15.0697C16.6573 16.042 15.9089 16.8678 14.3174 16.8678C13.6552 16.8678 13.0015 16.696 12.6746 16.515L12.941 15.4312C13.2938 15.6117 13.8359 15.7927 14.3948 15.7927C14.9975 15.7927 15.3153 15.5433 15.3153 15.1646C15.3155 14.8036 15.0403 14.5967 14.3435 14.3474ZM12.1248 15.6805V16.782H8.50273V10.9833H9.81941V15.6805H12.1248ZM4.29689 16.782H2.80014L4.47754 13.8478L2.8601 10.9831H4.36574L4.87299 12.0414C5.04507 12.3941 5.1742 12.6776 5.312 13.005H5.32873C5.46675 12.635 5.57846 12.377 5.72428 12.0414L6.21471 10.9831H7.7115L6.07696 13.8131L7.79776 16.7815H6.28388L5.75884 15.7318C5.54413 15.328 5.40638 15.0266 5.24287 14.6911H5.22577C5.10517 15.0266 4.95926 15.328 4.77843 15.7318L4.29689 16.782ZM20.5883 23.7542H4.41179V19.0315H20.5882V23.7542H20.5883ZM20.5971 16.782L20.0722 15.7323C19.8572 15.3282 19.7196 15.0271 19.5561 14.6916H19.5394C19.4188 15.0271 19.2723 15.3282 19.0914 15.7323L18.6103 16.782H17.1131L18.7905 13.8478L17.1731 10.9831H18.6787L19.1866 12.0414C19.3585 12.3941 19.4872 12.6776 19.6252 13.005H19.6423C19.7797 12.635 19.8913 12.377 20.0377 12.0414L20.528 10.9831H22.0251L20.3905 13.8131L22.111 16.7815H20.5971V16.782Z" fill="black"/>
											</svg>
										</Link> */}
											</span>
										</div>
										<div className="panel-body table-responsive mb-5" >
											<table className="table table-striped table-fixed">
												<thead>
													<tr>
														<th style={{ textAlign: 'center' }}>Total Available Apartments (Avg.)</th>
														<th style={{ textAlign: 'center' }}>Total Rented Apartments Last 30 days (Avg.)</th>
														<th style={{ textAlign: 'center' }}>Total Apartments Offering Incentive (Avg.)</th>
													</tr>
												</thead>
												<tbody>
													{/* {this.state.get_avg_total_market.length>0?get_avg_total_market:<tr><td colspan="3" style={{textAlign:'center'}}>No record found</td></tr>} */}
													<tr>
														<td align="center">{parseFloat(this.state.get_avg_total_market_avai_apartment != '' ? this.state.get_avg_total_market_avai_apartment : 0).toFixed(2)}</td>
														<td align="center">{parseFloat(this.state.get_avg_total_market_rented != '' ? this.state.get_avg_total_market_rented : 0).toFixed(2)}</td>
														<td align="center">{parseFloat(this.state.get_avg_total_market_incentives != '' ? this.state.get_avg_total_market_incentives : 0).toFixed(2)}</td>
													</tr>
												</tbody>

											</table>

										</div>
									</TabPanel>

									<TabPanel>
										<div style={{ maxWidth: '715px', margin: '20px auto' }}>
											<button class="btn btn-default search-filter pull-right mr-5" onClick={this.resetFilter} style={{ 'margin-bottom': '0px' }}><img src="/reset-filter.png" width="55" /></button>
											<div className="clearfix"></div></div>
										<div className="marketing-filter">
											<div className="row">
												<div className="col-sm-3">
													<div className="form-group">

														<DatePicker
															selected={this.state.from_Date}
															onChange={this.handleChangeDate}
															dateFormat="MMMM d, yyyy"
															timeCaption="time"
															className="form-control"
															id="from_Date"
															placeholderText="Date From"
														/>
														{/* <input type="Text" class="form-control" placeholder="Date From"/> */}
													</div>
												</div>
												<div className="col-sm-3">
													<div className="form-group">


														<DatePicker
															selected={this.state.to_Date}
															onChange={this.handleChangetoDate}
															dateFormat="MMMM d, yyyy"
															timeCaption="time"
															className="form-control"
															id="to_Date"
															placeholderText="Date To"
														/>
														{/* <input type="Text" class="form-control" placeholder="Date To"/> */}
													</div>
												</div>
												<div className="col-sm-4">
													<div className="form-group">
														<select class="form-control" id="changevalue" onChange={this.changevalue}>
															<option value="RLS_Open">RLS and Open</option>
															<option value="RLS">RLS</option>
															<option value="Open">Open</option>
														</select>
													</div>
												</div>
												<div className="col-sm-2 text-center">
													<div className="form-group">
														<div className="search-wrap"><button className="btn btn-default search-filter" disabled={!this.validation()} onClick={() => this.handlesetdate()}><img src="/search-filter.png" width="55" style={{ 'padding-right': '4px' }} /></button>
														</div>
													</div>
												</div>
											</div>

										</div>

										<div className="clearfix">
											<h2 className="pull-left">Average current price</h2>
											<span className="pull-right">
												{this.state.changevalue == 'RLS_Open' ? <CSVLink data={this.state.get_opens_RLS_avgprice} filename={"get_opens_RLS_avgprice.csv"}><img src="/csv_file.png" /></CSVLink> : this.state.changevalue == 'Open' ? <CSVLink data={this.state.get_opens_avgprice} filename={"get_opens_avgprice.csv"}><img src="/csv_file.png" /></CSVLink> : ''}

												{/* <Link to>
											<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M22.1692 8.94238H21.5689V6.04588C21.5689 6.02782 21.566 6.00963 21.5639 5.99116C21.5629 5.87626 21.5261 5.76332 21.4474 5.67381L16.627 0.167657C16.6255 0.166244 16.6241 0.165742 16.6231 0.164238C16.5944 0.132138 16.5609 0.105418 16.5254 0.0823468C16.515 0.075325 16.5044 0.069443 16.4934 0.063242C16.4628 0.0465993 16.4302 0.0326013 16.3967 0.0225245C16.3876 0.0201535 16.3794 0.0164146 16.3704 0.0140436C16.334 0.00538035 16.2962 0 16.2579 0H4.41179C3.87088 0 3.43142 0.439958 3.43142 0.98041V8.9421H2.8312C2.05738 8.9421 1.42993 9.56933 1.42993 10.3434V17.6302C1.42993 18.4036 2.05738 19.0315 2.8312 19.0315H3.43142V24.0196C3.43142 24.5601 3.87088 25 4.41179 25H20.5882C21.1287 25 21.5686 24.5601 21.5686 24.0196V19.0315H22.1689C22.9425 19.0315 23.5701 18.4039 23.5701 17.6303V10.3437C23.5701 9.56937 22.943 8.94238 22.1692 8.94238ZM4.41179 0.98041H15.7677V5.99627C15.7677 6.26711 15.9874 6.48647 16.2579 6.48647H20.5883V8.94233H4.41179V0.98041ZM14.3435 14.3474C13.3803 14.0118 12.7518 13.479 12.7518 12.6355C12.7518 11.6461 13.5776 10.8893 14.9458 10.8893C15.5992 10.8893 16.0812 11.0267 16.425 11.1817L16.1327 12.2395C15.9005 12.128 15.4877 11.9643 14.9199 11.9643C14.3521 11.9643 14.0769 12.2224 14.0769 12.5235C14.0769 12.8936 14.4039 13.0568 15.1521 13.3407C16.1755 13.7194 16.6573 14.2526 16.6573 15.0697C16.6573 16.042 15.9089 16.8678 14.3174 16.8678C13.6552 16.8678 13.0015 16.696 12.6746 16.515L12.941 15.4312C13.2938 15.6117 13.8359 15.7927 14.3948 15.7927C14.9975 15.7927 15.3153 15.5433 15.3153 15.1646C15.3155 14.8036 15.0403 14.5967 14.3435 14.3474ZM12.1248 15.6805V16.782H8.50273V10.9833H9.81941V15.6805H12.1248ZM4.29689 16.782H2.80014L4.47754 13.8478L2.8601 10.9831H4.36574L4.87299 12.0414C5.04507 12.3941 5.1742 12.6776 5.312 13.005H5.32873C5.46675 12.635 5.57846 12.377 5.72428 12.0414L6.21471 10.9831H7.7115L6.07696 13.8131L7.79776 16.7815H6.28388L5.75884 15.7318C5.54413 15.328 5.40638 15.0266 5.24287 14.6911H5.22577C5.10517 15.0266 4.95926 15.328 4.77843 15.7318L4.29689 16.782ZM20.5883 23.7542H4.41179V19.0315H20.5882V23.7542H20.5883ZM20.5971 16.782L20.0722 15.7323C19.8572 15.3282 19.7196 15.0271 19.5561 14.6916H19.5394C19.4188 15.0271 19.2723 15.3282 19.0914 15.7323L18.6103 16.782H17.1131L18.7905 13.8478L17.1731 10.9831H18.6787L19.1866 12.0414C19.3585 12.3941 19.4872 12.6776 19.6252 13.005H19.6423C19.7797 12.635 19.8913 12.377 20.0377 12.0414L20.528 10.9831H22.0251L20.3905 13.8131L22.111 16.7815H20.5971V16.782Z" fill="black"/>
											</svg>
										</Link> */}
											</span>
										</div>
										<div className="panel-body table-responsive mb-5" style={{ overflow: 'auto', maxHeight: '400px' }}>
											<table className="table table-striped table-fixed">
												<thead>
													<tr>
														<th style={{ textAlign: 'center' }}>Studio</th>
														<th style={{ textAlign: 'center' }}>1Bed</th>
														<th style={{ textAlign: 'center' }}>2Bed</th>
														<th style={{ textAlign: 'center' }}>3Bed</th>
														<th style={{ textAlign: 'center' }}>4Bed</th>
														<th style={{ textAlign: 'center' }}>Neighborhood
															{/* <Link to id="neighborClick" data-toggle="collapse" data-target="#neighborhood" className="icon-wrap status" onClick={this.StatusNeighborClick} ></Link>												
												<div id="neighbor" class="collapse table-collapse status-collapse"  ref={this.setWrapperRef1}>
												<div className="box">
												<input type="text" style={{maxWidth:'151px'}} id="searchNeighborParam" autoComplete="off" class="search-input" />
												<span onClick={this.resetsearchParm} className="pull-right">(X)</span>
												
													

												</div>
							 					</div> */}
														</th>
													</tr>
												</thead>
												<tbody>
													{this.state.changevalue == 'RLS_Open' ? this.state.get_opens_RLS_avgprice.length > 0 ? get_opens_RLS_avgprice : <tr><td colspan="6" style={{ textAlign: 'center' }}>No record found</td></tr> : this.state.changevalue == 'RLS' ? this.state.get_RLS_avgprice.length > 0 ? get_RLS_avgprice : <tr><td colspan="6" style={{ textAlign: 'center' }}>No record found</td></tr> : this.state.changevalue == 'Open' ? this.state.get_opens_avgprice.length > 0 ? get_opens_avgprice : <tr><td colspan="6" style={{ textAlign: 'center' }}>No record found</td></tr> : ''}
													{/* <tr>
													<td>$1,05,000</td>
													<td>$1,55,000</td>
													<td>$3,05,000</td>
													<td>$4,05,000</td>
													<td>$1,05,000</td>
													<td>Astoria</td>
												</tr>
												<tr>
													<td>$1,05,000</td>
													<td>$1,55,000</td>
													<td>$3,05,000</td>
													<td>$4,05,000</td>
													<td>$1,05,000</td>
													<td>Williamburg</td>
												</tr>
												<tr>
													<td>$1,05,000</td>
													<td>$1,55,000</td>
													<td>$3,05,000</td>
													<td>$4,05,000</td>
													<td>$1,05,000</td>
													<td>Upper East Side</td>
												</tr> */}
												</tbody>

											</table>

										</div>


										<div className="clearfix ">
											<h2 className="pull-left">Current number of available apartments</h2>
											<span className="pull-right">
												<CSVLink data={this.state.get_current_avai_apartment} filename={"get_current_avai_apartment.csv"}><img src="/csv_file.png" /></CSVLink>
												{/* <Link to>
											<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M22.1692 8.94238H21.5689V6.04588C21.5689 6.02782 21.566 6.00963 21.5639 5.99116C21.5629 5.87626 21.5261 5.76332 21.4474 5.67381L16.627 0.167657C16.6255 0.166244 16.6241 0.165742 16.6231 0.164238C16.5944 0.132138 16.5609 0.105418 16.5254 0.0823468C16.515 0.075325 16.5044 0.069443 16.4934 0.063242C16.4628 0.0465993 16.4302 0.0326013 16.3967 0.0225245C16.3876 0.0201535 16.3794 0.0164146 16.3704 0.0140436C16.334 0.00538035 16.2962 0 16.2579 0H4.41179C3.87088 0 3.43142 0.439958 3.43142 0.98041V8.9421H2.8312C2.05738 8.9421 1.42993 9.56933 1.42993 10.3434V17.6302C1.42993 18.4036 2.05738 19.0315 2.8312 19.0315H3.43142V24.0196C3.43142 24.5601 3.87088 25 4.41179 25H20.5882C21.1287 25 21.5686 24.5601 21.5686 24.0196V19.0315H22.1689C22.9425 19.0315 23.5701 18.4039 23.5701 17.6303V10.3437C23.5701 9.56937 22.943 8.94238 22.1692 8.94238ZM4.41179 0.98041H15.7677V5.99627C15.7677 6.26711 15.9874 6.48647 16.2579 6.48647H20.5883V8.94233H4.41179V0.98041ZM14.3435 14.3474C13.3803 14.0118 12.7518 13.479 12.7518 12.6355C12.7518 11.6461 13.5776 10.8893 14.9458 10.8893C15.5992 10.8893 16.0812 11.0267 16.425 11.1817L16.1327 12.2395C15.9005 12.128 15.4877 11.9643 14.9199 11.9643C14.3521 11.9643 14.0769 12.2224 14.0769 12.5235C14.0769 12.8936 14.4039 13.0568 15.1521 13.3407C16.1755 13.7194 16.6573 14.2526 16.6573 15.0697C16.6573 16.042 15.9089 16.8678 14.3174 16.8678C13.6552 16.8678 13.0015 16.696 12.6746 16.515L12.941 15.4312C13.2938 15.6117 13.8359 15.7927 14.3948 15.7927C14.9975 15.7927 15.3153 15.5433 15.3153 15.1646C15.3155 14.8036 15.0403 14.5967 14.3435 14.3474ZM12.1248 15.6805V16.782H8.50273V10.9833H9.81941V15.6805H12.1248ZM4.29689 16.782H2.80014L4.47754 13.8478L2.8601 10.9831H4.36574L4.87299 12.0414C5.04507 12.3941 5.1742 12.6776 5.312 13.005H5.32873C5.46675 12.635 5.57846 12.377 5.72428 12.0414L6.21471 10.9831H7.7115L6.07696 13.8131L7.79776 16.7815H6.28388L5.75884 15.7318C5.54413 15.328 5.40638 15.0266 5.24287 14.6911H5.22577C5.10517 15.0266 4.95926 15.328 4.77843 15.7318L4.29689 16.782ZM20.5883 23.7542H4.41179V19.0315H20.5882V23.7542H20.5883ZM20.5971 16.782L20.0722 15.7323C19.8572 15.3282 19.7196 15.0271 19.5561 14.6916H19.5394C19.4188 15.0271 19.2723 15.3282 19.0914 15.7323L18.6103 16.782H17.1131L18.7905 13.8478L17.1731 10.9831H18.6787L19.1866 12.0414C19.3585 12.3941 19.4872 12.6776 19.6252 13.005H19.6423C19.7797 12.635 19.8913 12.377 20.0377 12.0414L20.528 10.9831H22.0251L20.3905 13.8131L22.111 16.7815H20.5971V16.782Z" fill="black"/>
											</svg>
										</Link> */}
											</span>
										</div>
										<div className="panel-body table-responsive mb-5" style={{ overflow: 'auto', maxHeight: '400px' }}>
											<table className="table table-striped table-fixed">
												<thead>
													<tr>
														<th style={{ textAlign: 'center' }}>Number of Apartment</th>

														<th style={{ textAlign: 'center' }}>Neighborhood
															{/* <Link to id="neighborClick" data-toggle="collapse" data-target="#neighborhood" className="icon-wrap status" onClick={this.StatusNeighborClick1} ></Link>												
												<div id="neighbor1" class="collapse table-collapse status-collapse"  ref={this.setWrapperRef2}>
												<div className="box">
												<input type="text" style={{maxWidth:'151px'}} id="searchNeighborParam" autoComplete="off" class="search-input" />
												<span onClick={this.resetsearchParm} className="pull-right">(X)</span>
												
													

												</div>
							 					</div> */}
														</th>
													</tr>
												</thead>
												<tbody>
													{this.state.get_current_avai_apartment.length > 0 ? get_current_avai_apartment : <tr><td colspan="2" style={{ textAlign: 'center' }}>No record found</td></tr>}
													{/* <tr>
													<td>10</td>
													
													<td>Astoria</td>
												</tr>
												<tr>
													<td>20</td>												
													<td>Williamburg</td>
												</tr>
												<tr>
													<td>40</td>												
													<td>Upper East Side</td>
												</tr> */}
												</tbody>

											</table>

										</div>

										<div className="clearfix ">
											<h2 className="pull-left">Number of apartments sold in the last 30 days</h2>
											<span className="pull-right">
												<CSVLink data={this.state.get_lastmonth_rented} filename={"get_lastmonth_rented.csv"}><img src="/csv_file.png" /></CSVLink>
												{/* <Link to>
											<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M22.1692 8.94238H21.5689V6.04588C21.5689 6.02782 21.566 6.00963 21.5639 5.99116C21.5629 5.87626 21.5261 5.76332 21.4474 5.67381L16.627 0.167657C16.6255 0.166244 16.6241 0.165742 16.6231 0.164238C16.5944 0.132138 16.5609 0.105418 16.5254 0.0823468C16.515 0.075325 16.5044 0.069443 16.4934 0.063242C16.4628 0.0465993 16.4302 0.0326013 16.3967 0.0225245C16.3876 0.0201535 16.3794 0.0164146 16.3704 0.0140436C16.334 0.00538035 16.2962 0 16.2579 0H4.41179C3.87088 0 3.43142 0.439958 3.43142 0.98041V8.9421H2.8312C2.05738 8.9421 1.42993 9.56933 1.42993 10.3434V17.6302C1.42993 18.4036 2.05738 19.0315 2.8312 19.0315H3.43142V24.0196C3.43142 24.5601 3.87088 25 4.41179 25H20.5882C21.1287 25 21.5686 24.5601 21.5686 24.0196V19.0315H22.1689C22.9425 19.0315 23.5701 18.4039 23.5701 17.6303V10.3437C23.5701 9.56937 22.943 8.94238 22.1692 8.94238ZM4.41179 0.98041H15.7677V5.99627C15.7677 6.26711 15.9874 6.48647 16.2579 6.48647H20.5883V8.94233H4.41179V0.98041ZM14.3435 14.3474C13.3803 14.0118 12.7518 13.479 12.7518 12.6355C12.7518 11.6461 13.5776 10.8893 14.9458 10.8893C15.5992 10.8893 16.0812 11.0267 16.425 11.1817L16.1327 12.2395C15.9005 12.128 15.4877 11.9643 14.9199 11.9643C14.3521 11.9643 14.0769 12.2224 14.0769 12.5235C14.0769 12.8936 14.4039 13.0568 15.1521 13.3407C16.1755 13.7194 16.6573 14.2526 16.6573 15.0697C16.6573 16.042 15.9089 16.8678 14.3174 16.8678C13.6552 16.8678 13.0015 16.696 12.6746 16.515L12.941 15.4312C13.2938 15.6117 13.8359 15.7927 14.3948 15.7927C14.9975 15.7927 15.3153 15.5433 15.3153 15.1646C15.3155 14.8036 15.0403 14.5967 14.3435 14.3474ZM12.1248 15.6805V16.782H8.50273V10.9833H9.81941V15.6805H12.1248ZM4.29689 16.782H2.80014L4.47754 13.8478L2.8601 10.9831H4.36574L4.87299 12.0414C5.04507 12.3941 5.1742 12.6776 5.312 13.005H5.32873C5.46675 12.635 5.57846 12.377 5.72428 12.0414L6.21471 10.9831H7.7115L6.07696 13.8131L7.79776 16.7815H6.28388L5.75884 15.7318C5.54413 15.328 5.40638 15.0266 5.24287 14.6911H5.22577C5.10517 15.0266 4.95926 15.328 4.77843 15.7318L4.29689 16.782ZM20.5883 23.7542H4.41179V19.0315H20.5882V23.7542H20.5883ZM20.5971 16.782L20.0722 15.7323C19.8572 15.3282 19.7196 15.0271 19.5561 14.6916H19.5394C19.4188 15.0271 19.2723 15.3282 19.0914 15.7323L18.6103 16.782H17.1131L18.7905 13.8478L17.1731 10.9831H18.6787L19.1866 12.0414C19.3585 12.3941 19.4872 12.6776 19.6252 13.005H19.6423C19.7797 12.635 19.8913 12.377 20.0377 12.0414L20.528 10.9831H22.0251L20.3905 13.8131L22.111 16.7815H20.5971V16.782Z" fill="black"/>
											</svg>
										</Link> */}
											</span>
										</div>
										<div className="panel-body table-responsive mb-5" style={{ overflow: 'auto', maxHeight: '400px' }}>
											<table className="table table-striped table-fixed">
												<thead>
													<tr>
														<th style={{ textAlign: 'center' }}>Number of Apartment</th>

														<th style={{ textAlign: 'center' }}>Neighborhood
															{/* <Link to id="neighborClick" data-toggle="collapse" data-target="#neighborhood" className="icon-wrap status" onClick={this.StatusNeighborClick2} ></Link>												
												<div id="neighbor2" class="collapse table-collapse status-collapse"  ref={this.setWrapperRef3}>
												<div className="box">
												<input type="text" style={{maxWidth:'151px'}} id="searchNeighborParam" autoComplete="off" class="search-input" />
												<span onClick={this.resetsearchParm} className="pull-right">(X)</span>
												
													

												</div>
							 					</div> */}
														</th>
													</tr>
												</thead>
												<tbody>
													{this.state.get_lastmonth_rented.length > 0 ? get_lastmonth_rented : <tr><td colspan="2" style={{ textAlign: 'center' }}>No record found</td></tr>}
													{/* <tr>
													<td>10</td>
													
													<td>Astoria</td>
												</tr>
												<tr>
													<td>20</td>												
													<td>Williamburg</td>
												</tr>
												<tr>
													<td>40</td>												
													<td>Upper East Side</td>
												</tr> */}
												</tbody>

											</table>

										</div>
										{/* <div className="clearfix ">
									<h2 className="pull-left">Number of apartments offering an incentive</h2>
									<span className="pull-right">
									<CSVLink data={this.state.get_apartment_offer_incentives} filename={"get_apartment_offer_incentives.csv"}><svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M22.1692 8.94238H21.5689V6.04588C21.5689 6.02782 21.566 6.00963 21.5639 5.99116C21.5629 5.87626 21.5261 5.76332 21.4474 5.67381L16.627 0.167657C16.6255 0.166244 16.6241 0.165742 16.6231 0.164238C16.5944 0.132138 16.5609 0.105418 16.5254 0.0823468C16.515 0.075325 16.5044 0.069443 16.4934 0.063242C16.4628 0.0465993 16.4302 0.0326013 16.3967 0.0225245C16.3876 0.0201535 16.3794 0.0164146 16.3704 0.0140436C16.334 0.00538035 16.2962 0 16.2579 0H4.41179C3.87088 0 3.43142 0.439958 3.43142 0.98041V8.9421H2.8312C2.05738 8.9421 1.42993 9.56933 1.42993 10.3434V17.6302C1.42993 18.4036 2.05738 19.0315 2.8312 19.0315H3.43142V24.0196C3.43142 24.5601 3.87088 25 4.41179 25H20.5882C21.1287 25 21.5686 24.5601 21.5686 24.0196V19.0315H22.1689C22.9425 19.0315 23.5701 18.4039 23.5701 17.6303V10.3437C23.5701 9.56937 22.943 8.94238 22.1692 8.94238ZM4.41179 0.98041H15.7677V5.99627C15.7677 6.26711 15.9874 6.48647 16.2579 6.48647H20.5883V8.94233H4.41179V0.98041ZM14.3435 14.3474C13.3803 14.0118 12.7518 13.479 12.7518 12.6355C12.7518 11.6461 13.5776 10.8893 14.9458 10.8893C15.5992 10.8893 16.0812 11.0267 16.425 11.1817L16.1327 12.2395C15.9005 12.128 15.4877 11.9643 14.9199 11.9643C14.3521 11.9643 14.0769 12.2224 14.0769 12.5235C14.0769 12.8936 14.4039 13.0568 15.1521 13.3407C16.1755 13.7194 16.6573 14.2526 16.6573 15.0697C16.6573 16.042 15.9089 16.8678 14.3174 16.8678C13.6552 16.8678 13.0015 16.696 12.6746 16.515L12.941 15.4312C13.2938 15.6117 13.8359 15.7927 14.3948 15.7927C14.9975 15.7927 15.3153 15.5433 15.3153 15.1646C15.3155 14.8036 15.0403 14.5967 14.3435 14.3474ZM12.1248 15.6805V16.782H8.50273V10.9833H9.81941V15.6805H12.1248ZM4.29689 16.782H2.80014L4.47754 13.8478L2.8601 10.9831H4.36574L4.87299 12.0414C5.04507 12.3941 5.1742 12.6776 5.312 13.005H5.32873C5.46675 12.635 5.57846 12.377 5.72428 12.0414L6.21471 10.9831H7.7115L6.07696 13.8131L7.79776 16.7815H6.28388L5.75884 15.7318C5.54413 15.328 5.40638 15.0266 5.24287 14.6911H5.22577C5.10517 15.0266 4.95926 15.328 4.77843 15.7318L4.29689 16.782ZM20.5883 23.7542H4.41179V19.0315H20.5882V23.7542H20.5883ZM20.5971 16.782L20.0722 15.7323C19.8572 15.3282 19.7196 15.0271 19.5561 14.6916H19.5394C19.4188 15.0271 19.2723 15.3282 19.0914 15.7323L18.6103 16.782H17.1131L18.7905 13.8478L17.1731 10.9831H18.6787L19.1866 12.0414C19.3585 12.3941 19.4872 12.6776 19.6252 13.005H19.6423C19.7797 12.635 19.8913 12.377 20.0377 12.0414L20.528 10.9831H22.0251L20.3905 13.8131L22.111 16.7815H20.5971V16.782Z" fill="black"/>
											</svg></CSVLink> */}
										{/* <Link to>
											<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M22.1692 8.94238H21.5689V6.04588C21.5689 6.02782 21.566 6.00963 21.5639 5.99116C21.5629 5.87626 21.5261 5.76332 21.4474 5.67381L16.627 0.167657C16.6255 0.166244 16.6241 0.165742 16.6231 0.164238C16.5944 0.132138 16.5609 0.105418 16.5254 0.0823468C16.515 0.075325 16.5044 0.069443 16.4934 0.063242C16.4628 0.0465993 16.4302 0.0326013 16.3967 0.0225245C16.3876 0.0201535 16.3794 0.0164146 16.3704 0.0140436C16.334 0.00538035 16.2962 0 16.2579 0H4.41179C3.87088 0 3.43142 0.439958 3.43142 0.98041V8.9421H2.8312C2.05738 8.9421 1.42993 9.56933 1.42993 10.3434V17.6302C1.42993 18.4036 2.05738 19.0315 2.8312 19.0315H3.43142V24.0196C3.43142 24.5601 3.87088 25 4.41179 25H20.5882C21.1287 25 21.5686 24.5601 21.5686 24.0196V19.0315H22.1689C22.9425 19.0315 23.5701 18.4039 23.5701 17.6303V10.3437C23.5701 9.56937 22.943 8.94238 22.1692 8.94238ZM4.41179 0.98041H15.7677V5.99627C15.7677 6.26711 15.9874 6.48647 16.2579 6.48647H20.5883V8.94233H4.41179V0.98041ZM14.3435 14.3474C13.3803 14.0118 12.7518 13.479 12.7518 12.6355C12.7518 11.6461 13.5776 10.8893 14.9458 10.8893C15.5992 10.8893 16.0812 11.0267 16.425 11.1817L16.1327 12.2395C15.9005 12.128 15.4877 11.9643 14.9199 11.9643C14.3521 11.9643 14.0769 12.2224 14.0769 12.5235C14.0769 12.8936 14.4039 13.0568 15.1521 13.3407C16.1755 13.7194 16.6573 14.2526 16.6573 15.0697C16.6573 16.042 15.9089 16.8678 14.3174 16.8678C13.6552 16.8678 13.0015 16.696 12.6746 16.515L12.941 15.4312C13.2938 15.6117 13.8359 15.7927 14.3948 15.7927C14.9975 15.7927 15.3153 15.5433 15.3153 15.1646C15.3155 14.8036 15.0403 14.5967 14.3435 14.3474ZM12.1248 15.6805V16.782H8.50273V10.9833H9.81941V15.6805H12.1248ZM4.29689 16.782H2.80014L4.47754 13.8478L2.8601 10.9831H4.36574L4.87299 12.0414C5.04507 12.3941 5.1742 12.6776 5.312 13.005H5.32873C5.46675 12.635 5.57846 12.377 5.72428 12.0414L6.21471 10.9831H7.7115L6.07696 13.8131L7.79776 16.7815H6.28388L5.75884 15.7318C5.54413 15.328 5.40638 15.0266 5.24287 14.6911H5.22577C5.10517 15.0266 4.95926 15.328 4.77843 15.7318L4.29689 16.782ZM20.5883 23.7542H4.41179V19.0315H20.5882V23.7542H20.5883ZM20.5971 16.782L20.0722 15.7323C19.8572 15.3282 19.7196 15.0271 19.5561 14.6916H19.5394C19.4188 15.0271 19.2723 15.3282 19.0914 15.7323L18.6103 16.782H17.1131L18.7905 13.8478L17.1731 10.9831H18.6787L19.1866 12.0414C19.3585 12.3941 19.4872 12.6776 19.6252 13.005H19.6423C19.7797 12.635 19.8913 12.377 20.0377 12.0414L20.528 10.9831H22.0251L20.3905 13.8131L22.111 16.7815H20.5971V16.782Z" fill="black"/>
											</svg>
										</Link> */}
										{/* </span>	
								</div> */}
										{/* <div className="panel-body table-responsive mb-5" style={{overflow:'auto',maxHeight:'400px'}}>
										<table className="table table-striped table-fixed">
											<thead>
												<tr>
													<th  style={{textAlign:'center'}}>Number of Apartment</th>
												
													<th  style={{textAlign:'center'}}>Neighborhood  */}
										{/* <Link to id="neighborClick" data-toggle="collapse" data-target="#neighborhood" className="icon-wrap status" onClick={this.StatusNeighborClick3} ></Link>												
												<div id="neighbor3" class="collapse table-collapse status-collapse"  ref={this.setWrapperRef4}>
												<div className="box">
												<input type="text" style={{maxWidth:'151px'}} id="searchNeighborParam" autoComplete="off" class="search-input" />
												<span onClick={this.resetsearchParm} className="pull-right">(X)</span>
												
													

												</div>
							 					</div> */}
										{/* </th>
												</tr>
											</thead>
											<tbody>
												{this.state.get_apartment_offer_incentives.length>0?get_apartment_offer_incentives:<tr><td colspan="2" style={{textAlign:'center'}}>No record found</td></tr>} */}
										{/* <tr>
													<td>10</td>
													
													<td>Astoria</td>
												</tr>
												<tr>
													<td>20</td>												
													<td>Williamburg</td>
												</tr>
												<tr>
													<td>40</td>												
													<td>Upper East Side</td>
												</tr> */}
										{/* </tbody>

										</table>

								</div> */}

										<div className="clearfix ">
											<h2 className="pull-left">Average for the total market</h2>
											<span className="pull-right">
												{/* <CSVLink data={this.state.get_avg_total_market} filename={"get_avg_total_market.csv"}><img src="/csv_file.png" /></CSVLink> */}
												{/* <Link to>
											<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M22.1692 8.94238H21.5689V6.04588C21.5689 6.02782 21.566 6.00963 21.5639 5.99116C21.5629 5.87626 21.5261 5.76332 21.4474 5.67381L16.627 0.167657C16.6255 0.166244 16.6241 0.165742 16.6231 0.164238C16.5944 0.132138 16.5609 0.105418 16.5254 0.0823468C16.515 0.075325 16.5044 0.069443 16.4934 0.063242C16.4628 0.0465993 16.4302 0.0326013 16.3967 0.0225245C16.3876 0.0201535 16.3794 0.0164146 16.3704 0.0140436C16.334 0.00538035 16.2962 0 16.2579 0H4.41179C3.87088 0 3.43142 0.439958 3.43142 0.98041V8.9421H2.8312C2.05738 8.9421 1.42993 9.56933 1.42993 10.3434V17.6302C1.42993 18.4036 2.05738 19.0315 2.8312 19.0315H3.43142V24.0196C3.43142 24.5601 3.87088 25 4.41179 25H20.5882C21.1287 25 21.5686 24.5601 21.5686 24.0196V19.0315H22.1689C22.9425 19.0315 23.5701 18.4039 23.5701 17.6303V10.3437C23.5701 9.56937 22.943 8.94238 22.1692 8.94238ZM4.41179 0.98041H15.7677V5.99627C15.7677 6.26711 15.9874 6.48647 16.2579 6.48647H20.5883V8.94233H4.41179V0.98041ZM14.3435 14.3474C13.3803 14.0118 12.7518 13.479 12.7518 12.6355C12.7518 11.6461 13.5776 10.8893 14.9458 10.8893C15.5992 10.8893 16.0812 11.0267 16.425 11.1817L16.1327 12.2395C15.9005 12.128 15.4877 11.9643 14.9199 11.9643C14.3521 11.9643 14.0769 12.2224 14.0769 12.5235C14.0769 12.8936 14.4039 13.0568 15.1521 13.3407C16.1755 13.7194 16.6573 14.2526 16.6573 15.0697C16.6573 16.042 15.9089 16.8678 14.3174 16.8678C13.6552 16.8678 13.0015 16.696 12.6746 16.515L12.941 15.4312C13.2938 15.6117 13.8359 15.7927 14.3948 15.7927C14.9975 15.7927 15.3153 15.5433 15.3153 15.1646C15.3155 14.8036 15.0403 14.5967 14.3435 14.3474ZM12.1248 15.6805V16.782H8.50273V10.9833H9.81941V15.6805H12.1248ZM4.29689 16.782H2.80014L4.47754 13.8478L2.8601 10.9831H4.36574L4.87299 12.0414C5.04507 12.3941 5.1742 12.6776 5.312 13.005H5.32873C5.46675 12.635 5.57846 12.377 5.72428 12.0414L6.21471 10.9831H7.7115L6.07696 13.8131L7.79776 16.7815H6.28388L5.75884 15.7318C5.54413 15.328 5.40638 15.0266 5.24287 14.6911H5.22577C5.10517 15.0266 4.95926 15.328 4.77843 15.7318L4.29689 16.782ZM20.5883 23.7542H4.41179V19.0315H20.5882V23.7542H20.5883ZM20.5971 16.782L20.0722 15.7323C19.8572 15.3282 19.7196 15.0271 19.5561 14.6916H19.5394C19.4188 15.0271 19.2723 15.3282 19.0914 15.7323L18.6103 16.782H17.1131L18.7905 13.8478L17.1731 10.9831H18.6787L19.1866 12.0414C19.3585 12.3941 19.4872 12.6776 19.6252 13.005H19.6423C19.7797 12.635 19.8913 12.377 20.0377 12.0414L20.528 10.9831H22.0251L20.3905 13.8131L22.111 16.7815H20.5971V16.782Z" fill="black"/>
											</svg>
										</Link> */}
											</span>
										</div>
										<div className="panel-body table-responsive mb-5">
											<table className="table table-striped table-fixed">
												<thead>
													<tr>
														<th style={{ textAlign: 'center' }}>Total Available Apartments (Avg.)</th>
														<th style={{ textAlign: 'center' }}>Total Sold Apartments Last 30 days (Avg.)</th>
														{/* <th  style={{textAlign:'center'}}>Total Apartments Offering Incentive (Avg.)</th> */}
													</tr>
												</thead>
												<tbody>
													{/* {this.state.get_avg_total_market.length>0?get_avg_total_market:<tr><td colspan="3" style={{textAlign:'center'}}>No record found</td></tr>} */}
													<tr>
														<td align="center">{parseFloat(this.state.get_avg_total_market_avai_apartment != '' ? this.state.get_avg_total_market_avai_apartment : 0).toFixed(2)}</td>
														<td align="center">{parseFloat(this.state.get_avg_total_market_rented != '' ? this.state.get_avg_total_market_rented : 0).toFixed(2)}</td>
														{/* <td  align="center">{parseFloat(this.state.get_avg_total_market_incentives!=''?this.state.get_avg_total_market_incentives:0).toFixed(2)}</td> */}
													</tr>
												</tbody>

											</table>

										</div>
									</TabPanel>
								</Tabs>

							</div>
						</div>
					</div>
				</main>
			</div>
		);
	}
}
Buildings1.propTypes = {
	userType: PropTypes.string

};
export default Buildings1;
